import {konsole, elemIsVisible, doT, _, $} from '../util';
import _PHP from '../_PHP';
import _elem from '../modules/_elem';
import ResultItem from './ResultItem';
import FormApiEmbedded from './FormApiEmbedded';
import {sortOrders, dealerNameIds, dealers} from '../setup';
import SlimSelect from 'slim-select';
import {router} from '../routerAndLayout';

// http://slimselectjs.com/options
function slimSelectOnChange(data) {
  const value = Array.isArray(data) ? data.length > 0 : data.value;
  this.slim.container.classList.toggle('ss-value-selected', !!value);
}

function createSlimSelect({deselectable, select}) {
  const slimSelect = new SlimSelect({
    select: select,
    allowDeselectOption: deselectable,
    allowDeselect: deselectable,
    placeholder: select.getAttribute('placeholder') || '',
    searchPlaceholder: 'Szűrés:',
    showSearch: false,
    onChange: slimSelectOnChange
    // addToBody: true
  });

  if (deselectable) {
    slimSelect.slim.container.classList.add('ss-deselectable');
  }

  return slimSelect;
}

const instances = [];

const _defaults = {
  contact_note: ""
};

const _static = {
  uniqId: 0,
  resultItems: {}
};


class CarSearch {
  constructor(_setup) {
    this.setup = $.extend({}, _defaults, _setup);
    this.formid = this.setup.formid;
    this.fragment = document.createDocumentFragment();
    this.filterDebounced = _.debounce(this.filter, 10);
    this.currentOrder = this.setup.order || 'price_asc';
    this.dealerInfilterCriteria = !!this.setup.distinctDealer || false;
    this.$ = {
      filterForm: $(
        this.formTemplate({
          order: this.currentOrder,
          id: this.formid
        })
      ).appendTo(_setup.formSelector)
    };
    this.items = [];
    this.highlightedItem = null;

    this.$.inputs = {};
    this.$.resultList = $(this.setup.resultSelector);
    this.$.dealer_addresses = _elem("div", "clearfix dealers").attr('id', 'foot-addresses').append(
      $(dealerNameIds.map(d => (
        `<div class="dealer-address ${d}" id="foot-addresses-${d}">
          <div role="button" aria-pressed="false" tabindex="0" class="dealer-address-label">${dealers[d]}</div>
          <address>
            ${$(`#address-${d}`).html()}
            ${($(`#address-${d} + .mini-maps-contact__buttons .mini-maps-contact__link-button`)[0] ||
            {outerHTML: ''}).outerHTML}
          </address>
        </div>`
      )).join(''))
    ).on("click keypress", ".dealer-address-label", function(e) {
      if ($(e.target).is('p, a')) { return; }
      if (e.type === 'keypress' && e.which !== 13) { return; }
      $(this).parent()
        .toggleClass("active")
        .siblings()
        .removeClass("active")
      ;
      $(this).attr('aria-pressed', $(this).parent().hasClass('active'));
    });

    this.$.contact_note = _elem("div", "clearfix note").append(
      this.setup.contactNote
    );
    this.$.instructions = $(this.$.contact_note).append(this.$.dealer_addresses);
    this.$.filterForm.on(
      "click", ".adv-filter-show-more", () => {
        this.$.filterForm.addClass('adv-filter-enabled');
      }
    ).on(
      "click", ".adv-filter-show-less", () => {
        this.$.filterForm.removeClass('adv-filter-enabled');
        this.clearForm();
      }
    );

    this.formApiEmbedded = new FormApiEmbedded(
      this.formid + "-rfo", {
        leadtl: _PHP.leadtl,
        leadctx: _PHP.leadctx,
        leadctxid: _PHP.leadctxid
      },
      this
    );

    this.viewPortUpdationsDelayed = _.debounce(this.viewPortUpdations, 100, {
      maxWait: 75,
      leading: false
    });

    instances.push(this);
    this.init();
  }

  init() {
    const that = this;

    if (this.initialized) {
      return;
    }
    this.initialized = true;

    this.$.filterForm
      .find(":input")
      .each(function() {
        if (this.name) {
          that.$.inputs[this.name] = $(this);
        }
      })
      .filter("select")
      .each(function() {
        const $that = $(this);
        $that.parent().css('min-width', $that.width());
        const deselectable = this.getAttribute('data-allow-deselect') === 'true';
        this._slimSelect = createSlimSelect({
          deselectable,
          select: this
        });
      })
      .change();

    this.build();
    this.buildForm();
    this.filter(true, {log: 'init'});

    router.on('nocarid', (data, {history, path}) => {
      this.closeAll();
    });
  };

  appendAllToResult() {
    for (let i = 0; i < this.items.length; i++) {
      this.fragment.appendChild(this.items[i].$out[0]);
    }
    this.$.resultList[0].appendChild(this.fragment);
  };

  highlight(item) {
    if (this.highlightedItem instanceof ResultItem) {
      this.highlightedItem.unsetHighlight();
      this.highlightedItem = null;
    }
    if (item instanceof ResultItem) {
      this.highlightedItem = item.setHighlight();
    }
    return this;
  };

  viewPortUpdations() {
    if (elemIsVisible(this.$.resultList[0])) {
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].recalc();
      }
    }
  };

  triggerFormChange() {
    for (const input in this.$.inputs) {
      if (this.$.inputs.hasOwnProperty(input)) {
        this.$.inputs[input].trigger("change", [true]);
      }
    }
  };

  clearForm() {
    this.$.filterForm[0].reset();
    for (const name in this.$.inputs) {
      if (this.$.inputs.hasOwnProperty(name)) {
        const input = this.$.inputs[name][0];
        if (input._slimSelect) {
          input._slimSelect.set(input._slimSelect.config.isMultiple ? [] : input.options[0].value);
        }
      }
    }

    this.triggerFormChange();
    return this;
  };


  buildForm() {
    const that = this;

    function changeEvent(e, bypassFilter) {
      const val = that.$.inputs.order.val();
      if (this.name === "order") {
        that.sort(val);
        return;
      }
      if (!bypassFilter) {
        // t.filter(this.name, val);
        // todo move dealerInfilterCriteria here
        that.filterDebounced(null, {log: 'buildForm'});
      }
      if (this.name === "dealer") {
        that.sort(val);
      }
    }

    for (const name in this.$.inputs) {
      this.$.inputs[name].change(changeEvent);

      if (this.$.inputs.hasOwnProperty(name) && this.$.inputs[name].is("select")) {
        const options = [];

        if (name === "dealer" || name === "order") {
          continue;
        }

        for (let i = 0, item; i < this.items.length; i++) {
          item = this.items[i];
          if (!Array.isArray(item.data[name]) && item.data[name] && options.indexOf(item.data[name]) === -1) {
            options.push(item.data[name]);
          }
        }

        if (!this.$.inputs[name].attr('placeholder') && name !== 'order' && name !== 'state' && name !== 'transmission_f') {
          this.$.inputs[name].append('<option value="">Mindegy</option>');
        }
        if (name === "type") {
          options.sort(sortOrders.sortIndexByType);
        }
        if (name === "model") {
          options.sort(sortOrders.sortIndexByModel);
        }

        for (let i = 0; i < options.length; i++) {
          this.$.inputs[name].append(
            '<option value="' + options[i] + '">' + options[i] + "</option>"
          );
        }
      }
    }
    // t.$.inputs.order.change();
    this.sort(this.$.inputs.order.val(), true);
  };

  filter(noRecalc, _meta) {
    // console.log(1, _meta);

    const inputValues = {};
    let visible = 0;
    const distinctDealer = this.setup.distinctDealer;

    for (const input in this.$.inputs) {
      if (this.$.inputs.hasOwnProperty(input)) {
        const v = this.$.inputs[input].val();
        inputValues[input] = v === null ? '' : v;
      }
    }


    this.dealerInfilterCriteria = !!distinctDealer || (
      Array.isArray(inputValues.dealer) && inputValues.dealer.length > 0
    );

    for (let i = 0, item; i < this.items.length; i++) {
      item = this.items[i];
      let showresult = true;
      const pass = {};

      if (distinctDealer && distinctDealer in item.data.dealer !== true) {
        showresult = false;
      }
      else {

        if (
          Array.isArray(inputValues.dealer) &&
          inputValues.dealer.filter((d) => item.data.dealer[d]).length === 0
        ) {
          showresult = false;
        }

        for (const inputname in inputValues) {
          if (!inputValues.hasOwnProperty(inputname)) {
            continue;
          }

          const val = inputValues[inputname];
          const data = item.data[inputname];
          const valIsArray = Array.isArray(val);
          const dataIsArray = Array.isArray(data);

          if (inputname === "order" || inputname === "dealer") {
            continue;
          }

          pass[inputname] = false;

          if (val === "" || val === null) {
            pass[inputname] = "Üres érték";
          }
          else if (inputname === "state") {
            if (val === "new" && item.data.newcar) {
              pass[inputname] = 'Új Minikre való szűrés';
            }
            else if (val === "used" && !item.data.newcar) {
              pass[inputname] = 'Használt Minikre való szűrés';
            }
          }

          else if (dataIsArray && valIsArray) {
            pass[inputname] = "a data és a val tömb, val minden értéket tartalmaz ami databan van";
            for (let d = 0; d < val.length; d++) {
              if (data.indexOf(val[d]) === -1) {
                pass[inputname] = false;
                break;
              }
            }
          }
          else if (dataIsArray && !valIsArray) {
            for (let d = 0; d < data.length; d++) {
              if (data.indexOf(val) > -1) {
                pass[inputname] = 'A data tömb, a val str és a data-ban szerepel ';
                break;
              }
            }
          }
          else if (
            (valIsArray && val.indexOf(data) > -1) ||
            (!valIsArray && data === val)
          ) {
            pass[inputname] =
              "A data-ban is szepelő tulajdonság értéke megegyezik az azonos nevű input mező értékével";
          }
        }
      }

      if (showresult) {
        for (const inputname in pass) {
          if (pass.hasOwnProperty(inputname) && pass[inputname] === false) {
            showresult = false;
            break;
          }
        }
      }

      if (showresult) {
        item.show();
        visible++;
      }
      else {
        item.hide();
      }
    }

    this.$.filterForm.toggleClass("no-result", visible === 0);

    if (!noRecalc) {
      this.viewPortUpdations();
    }
  };

  getActiveItem() {
    return this._getResultItem(null, 'expanded', true, true);
  }

  getActiveIndex() {
    const resultItem = this.getActiveItem();
    if (resultItem instanceof ResultItem) {
      return this.items.indexOf(resultItem);
    }
    return -1;
  }

  activateNext() {
    const activeIndex = this.getActiveIndex();
    if (activeIndex > -1 && activeIndex < this.items.length - 1) {
      for (let i = activeIndex + 1; i < this.items.length; i++) {
        if (!this.items[i].hidden) {
          this.items[i].activateItem();
          break;
        }
      }
    }
  }

  activatePrev() {
    const activeIndex = this.getActiveIndex();
    if (activeIndex > -1 && activeIndex > 0) {
      for (let i = activeIndex - 1; i >= 0; i--) {
        if (!this.items[i].hidden) {
          this.items[i].activateItem();
          break;
        }
      }
    }
  }

  _getResultItem(
    whereToFind = null,
    prop,
    val,
    first
  ) {
    const found = [];

    for (let i = 0, obj; i < this.items.length; i++) {
      obj = this.items[i];

      if (whereToFind) {
        if (
          obj[whereToFind] === null ||
          typeof obj[whereToFind] !== "object"
        ) {
          continue;
        }
        obj = obj[whereToFind];
      }
      if (obj[prop] === val) {
        if (first) {
          return this.items[i];
        }
        found.push(this.items[i]);
      }
    }
    return first ? null : found;
  };

  closeAll() {
    const openedResultItems = this.getResultItemBy("expanded", true);
    openedResultItems.forEach(resultItem => {
      if (resultItem instanceof ResultItem) {
        resultItem.hideDetails();
      }
    });
  };

  closeAllInAnyInstance() {
    const openedResultItems = this.getResultItemFromAnyInstanceBy("expanded", true);
    _.flatten(openedResultItems).forEach(resultItem => {
      if (resultItem instanceof ResultItem) {
        resultItem.hideDetails();
      }
    });
  };

  getResultItemFromAnyInstanceBy(prop, val, first) {
    return instances.map((instance) => instance.getResultItemBy(prop, val, first));
  };

  getResultItemBy(prop, val, first) {
    return this._getResultItem(false, prop, val, first);
  };

  getResultItemByData(prop, val, first) {
    return this._getResultItem("data", prop, val, first);
  };

  executeOnItems(method, args) {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i][method]) {
        this.items[i][method].apply(this.items[i], args);
      }
    }
  };

  build() {
    this.$.resultList.empty();
    for (let i = 0, item; i < this.setup.items.length; i++) {
      item = this.setup.items[i];
      if (item.prc_instant_price === 0) {
        // continue;
      }
      if (
        this.setup.distinctDealer &&
        item.dealer.indexOf(this.setup.distinctDealer) === -1
      ) {
        continue;
      }
      if (item.sold_old) {
        continue;
      }
      _static.uniqId++;

      const resultItem = new ResultItem(item, this, _static.uniqId);
      _static.resultItems[resultItem.id] = item._ref = resultItem;
      this.items.push(resultItem);
      resultItem.init();
    }
    // this.$.resultList.append(
    //   '<div class=""></div>'
    // );
  };

}


CarSearch.prototype.sort = (function() {
  function sort_price(a, b) {
    return compareAscending(
      a.data.prc_instant_price,
      b.data.prc_instant_price
    );
  }

  function sort_discount(a, b) {
    return compareAscending(a.data.prc_savings, b.data.prc_savings);
  }

  function sort_registrated(a, b) {
    if (a.data.registrated < b.data.registrated) {
      return -1;
    }
    if (a.data.registrated > b.data.registrated) {
      return 1;
    }
    return 0;
  }

  function sort_engine(a, b) {
    // diesel / benzin
    const engine = sortOrders.sortIndexByEngine(
      a.data.engine,
      b.data.engine,
      true
    );
    const model = sortOrders.sortIndexByModel(
      a.data.model,
      b.data.model,
      true
    );
    const type = sortOrders.sortIndexByType(
      a.data.type,
      b.data.type,
      true
    );
    return (
      engine.a * 10000 +
      model.a * 100 +
      type.a -
      (engine.b * 10000 + model.b * 100 + type.b)
    );
  }

  function sort_sold(a, b) {
    if (a.data.sold < b.data.sold) {
      return -1;
    }
    if (a.data.sold > b.data.sold) {
      return 1;
    }
    return 0;
  }

  function sort_model(a, b) {
    const model = sortOrders.sortIndexByModel(
      a.data.model,
      b.data.model,
      true
    );
    const type = sortOrders.sortIndexByType(
      a.data.type,
      b.data.type,
      true
    );
    return model.a * 100 + type.a - (model.b * 100 + type.b);
  }

  function sort_unique(a, b, carSearch) {
    const model = sortOrders.sortIndexByModel(
      a.data.model,
      b.data.model,
      true
    );
    const type = sortOrders.sortIndexByType(
      a.data.type,
      b.data.type,
      true
    );


    if (carSearch.dealerInfilterCriteria) {
      if (a.data.availabile_anywhere !== b.data.availabile_anywhere) {
        return a.data.availabile_anywhere > b.data.availabile_anywhere ? 3 : -3;
      }
    }

    if (model.a !== model.b) {
      return model.a > model.b ? 2 : -2;
    }
    if (type.a !== type.b) {
      return type.a > type.b ? 1 : -1;
    }

    if (a.data.prc_instant_price !== b.data.prc_instant_price) {
      return compareAscending(
        a.data.prc_instant_price,
        b.data.prc_instant_price
      );
    }

    return 0;
  }

  function compareAscending(a, b) {
    if (a !== b) {
      if (a > b || a === undefined) {
        return 1;
      }
      if (a < b || b === undefined) {
        return -1;
      }
    }
    return 0;
  }

  function placeItemsTopBy(items, dataProperty) {
    const topItems = [];
    let i = items.length;
    while (--i > 0) {
      if (items[i].data[dataProperty]) {
        topItems.push(items.splice(i, 1)[0]);
      }
    }
    if (topItems.length) {
      Array.prototype.unshift.apply(items, topItems);
    }
    return items;
  }

  const sorfns = {
    registrated_asc(items, that) {
      items.sort((a, b) => sort_registrated(a, b, that)).reverse();
    },
    registrated_desc(items, that) {
      items.sort((a, b) => sort_registrated(a, b, that));
    },
    model_asc(items, that) {
      items.sort((a, b) => sort_model(a, b, that));
    },
    model_desc(items, that) {
      items.sort((a, b) => sort_model(a, b, that)).reverse();
    },
    price_asc(items, that) {
      items.sort((a, b) => sort_price(a, b, that));
    },
    price_desc(items, that) {
      items.sort((a, b) => sort_price(a, b, that)).reverse();
    },
    discount_asc(items, that) {
      items.sort((a, b) => sort_discount(a, b, that));
    },
    discount_desc(items, that) {
      items.sort((a, b) => sort_discount(a, b, that)).reverse();
    },
    unique(items, that) {
      items.sort((a, b) => sort_unique(a, b, that));
    },
    engine(items, that) {
      items.sort((a, b) => sort_engine(a, b, that));
    },
    sold(items, that) {
      items.sort((a, b) => sort_sold(a, b, that));
    }
  };

  return function(order, noRecalc) {
    // CarSearch.sort() method
    this.currentOrder = order;

    if (sorfns[order]) {
      sorfns[order](this.items, this);

      if (order === "discount_desc" || order === "price_asc") {
        placeItemsTopBy(this.items, "alwaysontop");
      }

      this.appendAllToResult();
      // this.executeOnItems("appendToResult");
    }
    else if (order !== "") {
      konsole.log("This sort order has not implemented.", order);
    }

    this.filterDebounced(noRecalc);
  };
})();

CarSearch.prototype.formTemplate = doT.template($("#filter-form").html());

CarSearch.ResultItem = ResultItem;
CarSearch.FormApiEmbedded = FormApiEmbedded;

function CarSearchCloseAllInstances() {
  if (instances.length) {
    instances[0].closeAllInAnyInstance();
  }
};

CarSearch.closeAll = CarSearchCloseAllInstances;


export default CarSearch;
export {
  CarSearchCloseAllInstances
};
